import React, {useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import Kpi from '../publisher/kpis/Kpi';
import PercentGaugeKpi from '../publisher/kpis/PercentGaugeKpi';
import {formatNumber} from "../Format";

export const KpisContainer = styled.div`
  background: white;
  width: 100%;
  margin-bottom: 60px;
  margin-top: 60px;
  box-shadow: 0px 0px 17px #CCCCCC;
  display: flex;
`

export default function Kpis ({ data = {} }) {
  const { t, i18n } = useTranslation();
  const computeKpis = () => {
    let { devices = 0, location_authorized_devices = 0, loc_consented_devices = 0 } = data
    let optIn = devices == 0 ? 0 : 100 * location_authorized_devices/devices
    let consent = location_authorized_devices == 0 ? 0 : 100 * loc_consented_devices/location_authorized_devices
    return {
      devices: devices,
      optIn,
      authorizedGeoloc: location_authorized_devices,
      consent,
      consentCount: loc_consented_devices
    }
  }
  const { devices, optIn, authorizedGeoloc, consent, consentCount } =  useMemo(
    () => ( computeKpis() ),
    [ data.devices, data.location_authorized_devices, data.loc_consented_devices]
  )

  return (
    <KpisContainer>
      <Kpi icon={'mobile'} value={formatNumber(devices, {}, i18n)} title={t("publisher.devices")}/>
      <PercentGaugeKpi value={optIn} title={t("publisher.optIn")}/>
      <Kpi icon={'location'} value={formatNumber(authorizedGeoloc, {}, i18n)} title={t("publisher.authorizedGeoloc")} ></Kpi>
      <PercentGaugeKpi value={consent} title={t("publisher.consent")}/>
      <Kpi icon='consent' value={formatNumber(consentCount, {}, i18n)} title={t("publisher.consentCount")} ></Kpi>
    </KpisContainer>
  )
}
